import React, { useState, useCallback } from 'react';
import i18next from 'i18next';
import { Item, Img } from '../../../StyledComponents/Lightbox/wrapper';
import MediaButton from '../../../StyledComponents/Gallery/MediaButton';
import Rotation from './Rotation';

type PropsType = {
  urls: string[];
};

const ThreeSixtyLightbox = ({ urls }: PropsType) => {
  const [started, setStarted] = useState(false);

  const onStart = useCallback(() => setStarted(true), []);

  if (!started) {
    return (
      <Item>
        <Img src={urls[0]} alt="alt" />
        <MediaButton text={i18next.t('item.start360Exterior')} onClick={onStart} />
      </Item>
    );
  }

  return (
    <Rotation>
      {urls.map((image, i) => (
        <Img key={image} src={image} alt={i18next.t('common.imageIndex', { index: i + 1 }) || ''} />
      ))}
    </Rotation>
  );
};

export default ThreeSixtyLightbox;
